<template>
  <div id="app">
    <navbar @langChange="changeLang" ref="nav" />
    <el-container>
      <!-- <keep-alive>
        <router-view></router-view>
      </keep-alive> -->
      <router-view />
    </el-container>
    <footerPage />
  </div>
</template>

<script>
import navbar from './components/navbar'
import footerPage from './components/footerPage'
import { setLang, getNav } from './api/api.js'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    navbar,
    footerPage
  },
  computed: {
    ...mapGetters({
      nav: 'getNav'
    })
  },
  methods: {
    ...mapMutations(['setNav']),
    changeLang(temp) {
      let locale = localStorage.getItem('language') || 'zh';
      let temp1 = temp//locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = temp1;//改变当前语言
      localStorage.language = temp1;
      // console.log(temp)
      var data = {
        lang: temp == 'en' ? 'en' : 'cn'
      }
      setLang(data).then(res => {
        // console.log(res)
        if (res.code == 1) {
          console.log(123)
          window.location.reload()
        }
      })
    },
    getData() {
      getNav().then(res => {
        if (res.code == 1) {
          this.setNav(res.data)

          this.$nextTick(() => {
            // this.$refs.nav.navFn()
          })
          // console.log(this.nav)
        }
        // console.log(res)
      })
    }
  },
  created() {
    // console.log(this.nav)
  },
  mounted() {
    this.getData()
  }
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}

html {
  font-size: 16px;
  padding: 0;
  margin: 0;
}

body {
  font-size: 16px;
  margin: 0;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style-type: none;
}

p {
  margin: 0;
  padding: 0;
}

.img-100 {
  width: 100%;
  height: 100%;
}
</style>
